/**
 * Адрес первой версии админки (hypercube) — без завершающего `/`.
 *
 * Значение по умолчанию то же, что у HYPERCUBE_URL на бэкенде: кабинет и API
 * должны уводить на один и тот же стенд, иначе с тестового контура человек
 * попадёт в боевую админку. Переменной окружения хватает, чтобы развести их.
 */
export const getAdminOrigin = () => {
  const raw = process.env.REACT_APP_FW_ADMIN || "https://hypercube.fairyland.world";
  return raw.replace(/\/$/, "").trim();
};

/**
 * Ссылка в конструктор старой админки.
 *
 * Вести прямо на /cabinet-school/index нельзя: у старой админки своя сессия,
 * и без неё страница отвечает 500 — не редиректом на вход, а именно ошибкой
 * «Возникла внутренняя ошибка сервера». Человек нажимал кнопку и упирался
 * в неё (проверено 25.08.2026 на боевом и тестовом hypercube).
 *
 * Правильный путь — через /auth/birthday: он принимает JWT платформы,
 * заводит сессию админки и сам перебрасывает в конструктор
 * (AuthController::actionBirthday, там redirect на cabinet-school/index).
 *
 * Токен берём тот же, которым кабинет ходит в API: подпись общая
 * (JWT_SECRET), поэтому админка его принимает.
 *
 * ЗАМЕЧАНИЕ ПРО БЕЗОПАСНОСТЬ. Токен уезжает в адресной строке, а значит
 * попадает в логи nginx и в историю браузера. Заголовком его не передать —
 * обычная ссылка заголовков не шлёт, а бэкенд читает и заголовок, и
 * параметр. Если это окажется неприемлемо, правильное решение — не менять
 * фронт, а завести на стороне админки одноразовый код обмена.
 */
export const getAdminConstructorUrl = () => {
  const origin = getAdminOrigin();
  const token = (() => {
    try {
      return localStorage.getItem("token") || "";
    } catch (e) {
      /* Приватный режим Safari запрещает localStorage — ссылка всё равно
         должна вести хоть куда-то. */
      return "";
    }
  })();

  /* Без токена /auth/birthday ответит «Нет токена». Ведём на корень админки:
     там человек увидит форму входа, а не ошибку. */
  if (!token) return origin;

  return `${origin}/auth/birthday?token=${encodeURIComponent(token)}`;
};
